'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _SelectArrows = require('./SelectArrows');

var _SelectArrows2 = _interopRequireDefault(_SelectArrows);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Select = function (_Component) {
  (0, _inherits3.default)(Select, _Component);

  function Select() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Select);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Select.__proto__ || (0, _getPrototypeOf2.default)(Select)).call.apply(_ref, [this].concat(args))), _this), _this.className = function () {
      var _this$props = _this.props,
          success = _this$props.success,
          warning = _this$props.warning,
          error = _this$props.error,
          parentWidth = _this$props.parentWidth;

      return (0, _classnames2.default)({
        'quiver-select': true,
        'quiver-select--parent-width': parentWidth,
        'quiver-select--success': success,
        'quiver-select--warning': warning,
        'quiver-select--error': error
      });
    }, _this.optionsList = function (options) {
      return options.map(function (option) {
        return _react2.default.createElement(
          'option',
          { value: option.value, key: option.value },
          option.text
        );
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Select, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          label = _props.label,
          select = _props.select,
          options = _props.options,
          defaultValue = _props.defaultValue,
          message = _props.message,
          style = _props.style;


      return _react2.default.createElement(
        'div',
        { className: this.className(), style: style },
        _react2.default.createElement(
          'label',
          { htmlFor: id, style: style && style.label },
          label
        ),
        _react2.default.createElement(
          'select',
          (0, _extends3.default)({}, select, { id: id, defaultValue: defaultValue, style: style && style.select }),
          this.optionsList(options)
        ),
        _react2.default.createElement(_SelectArrows2.default, null),
        message ? _react2.default.createElement(
          'div',
          { className: 'quiver-select__message', style: style && style.message },
          message
        ) : null
      );
    }
  }]);
  return Select;
}(_react.Component);

Select.propTypes = {
  id: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string,
  label: _propTypes2.default.string,
  message: _propTypes2.default.string,
  error: _propTypes2.default.bool,
  success: _propTypes2.default.bool,
  warning: _propTypes2.default.bool,
  parentWidth: _propTypes2.default.bool,
  select: _propTypes2.default.object,
  options: _propTypes2.default.array,
  style: _propTypes2.default.object
};
Select.defaultProps = {
  options: []
};
exports.default = Select;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Select/Select.js
// module id = 648
// module chunks = 11